<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="新建"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="workLineInfo"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="产线">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="workLineInfo.productionLine" disabled placeholder="请输入" readonly>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectWorkLineInfo.open()">选择</el-button>
            </el-input>
            <work-line-info-select ref="selectWorkLineInfo" @select="selectWorkLineInfo"/>
          </div>
        </el-form-item>
        <el-form-item label="工序">
          <el-input v-model="workLineInfo.process" disabled/>
        </el-form-item>
        <el-form-item label="处理人">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="workLineInfo.employeeName" disabled placeholder="请输入" readonly>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectUser.open()">选择</el-button>
            </el-input>
            <!--            <employee-select ref="selectEmployee" @select="selectEmployee"/>-->
            <user-select ref="selectUser" @select="selectUser"/>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import WorkLineInfoSelect from "@/views/information/WorkLineInfoHandler/workLineInfoSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name:"WorkLineInfoHandlerCreate",
    components: {UserSelect, WorkLineInfoSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        workLineInfo: {
          employeeName: "",
          mastPKID: "",
          pkid: "",
          process: "",
          processCode: "",
          productionLine: "",
          productionLineCode: "",
        },
        ruleValidate: {
          departmentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.workLineInfo.pkid = id;
        // console.log(id);
        this.dialogVisible = true;
        this.getNode();
      },
      selectWorkLineInfo(row) {
        console.log(row);
        // this.workLineInfo.pkid = row.pkid;
        this.workLineInfo.productionLine = row.cname;
        this.workLineInfo.ProductionLineCode = row.ccode;
        this.workLineInfo.process = row.processName;
        this.workLineInfo.processCode = row.code;
      },
      selectUser(row) {
        console.log(row);
        // this.workLineInfo.employeeID = row.employeeID;
        this.workLineInfo.employeeName = row.employeeName;
        this.workLineInfo.mastPKID = row.systemUserID;
      },

      getNode() {
        this.$http
          .get("basic", "systemUserWorkLines")
          .then(resp => {
            console.log(resp);
            //this.department.departmentNO = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "systemUserWorkLines", this.workLineInfo)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
